(function () {
  var FIELDSET_CLASS = "customer-register-grid";
  var FIELD_CLASS = "field customer-register-field";

  function normalizeText(value) {
    return (value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  function isRegisterForm(form) {
    var hasPassword = !!form.querySelector('input[type="password"], input[name="customer[password]"], input[name="password"]');
    var hasEmail = !!form.querySelector('input[type="email"], input[name="customer[email]"], input[name="email"]');
    var hasCreateCustomer = !!form.querySelector('input[name="form_type"][value="create_customer"]');
    var hasCustomerLogin = !!form.querySelector('input[name="form_type"][value="customer_login"]');
    var hasRegisterIdentityField = !!form.querySelector(
      'input[name="customer[first_name]"], input[name="customer[last_name]"], input[name="first_name"], input[name="last_name"], input[name="company-field"], input[id*="company"], input[id*="first"], input[id*="last"]'
    );
    var formText = normalizeText(form.textContent);
    var action = normalizeText(form.getAttribute("action"));

    if (hasCustomerLogin || action.indexOf("/account/login") !== -1) {
      return false;
    }

    return hasPassword && hasEmail && (hasCreateCustomer || hasRegisterIdentityField || formText.indexOf("criar conta") !== -1);
  }

  function findWrapper(element) {
    if (!element) {
      return null;
    }

    return (
      element.closest(
        ".field, .form-group, .form-field, .bss-fb-render, .bss-fb-element, .bss-b2b-rf-field, .ymq-lock-account-item, .form__field, .customer-field, [class*='field-']"
      ) || element.parentElement
    );
  }

  function setHidden(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }

    input.value = value || "";
  }

  function ensureLastName(form) {
    if (!form || !isRegisterForm(form)) {
      return;
    }

    setHidden(form, "customer[last_name]", "-");
  }

  function getValue(form, selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var input = form.querySelector(selectors[i]);

      if (input && input.value) {
        return input.value;
      }
    }

    return "";
  }

  function syncAddressFields(form) {
    if (!form) {
      return;
    }

    if (form.closest(".ymq-lock-register-form")) {
      return;
    }

    var company = getValue(form, ['#company-field', '#RegisterForm-Company', 'input[name="customer[first_name]"]']);
    var city = getValue(form, ['#city-field', '#RegisterForm-City', 'input[name="customer[note][Cidade]"]']);
    var state = getValue(form, ['#state-field', '#RegisterForm-State', 'input[name="customer[note][UF]"]']);
    var phone = getValue(form, ['#phone-field', '#RegisterForm-Phone', 'input[name="customer[note][Telefone]"]']);

    setHidden(form, "customer[default_address][company]", company);
    setHidden(form, "customer[default_address][city]", city);
    setHidden(form, "customer[default_address][province]", state);
    setHidden(form, "customer[default_address][province_code]", state);
    setHidden(form, "customer[default_address][phone]", phone);
    setHidden(form, "customer[default_address][country]", "Brazil");
    setHidden(form, "customer[default_address][country_code]", "BR");
  }

  function bindAddressSync(form) {
    if (!form || form.dataset.customerAddressSync === "true") {
      return;
    }

    if (form.closest(".ymq-lock-register-form")) {
      return;
    }

    form.addEventListener("input", function () {
      syncAddressFields(form);
    });
    form.addEventListener("submit", function () {
      syncAddressFields(form);
    });
    form.dataset.customerAddressSync = "true";
    syncAddressFields(form);
  }

  function createInputField(options) {
    var wrapper = document.createElement("div");
    wrapper.className = FIELD_CLASS + (options.full ? " customer-register-field--full" : "");

    var input = document.createElement("input");
    input.type = options.type || "text";
    input.id = options.id;
    input.name = options.name;
    input.autocomplete = options.autocomplete || "";
    input.placeholder = options.label;
    input.required = true;

    if (options.inputMode) {
      input.inputMode = options.inputMode;
    }

    var label = document.createElement("label");
    label.setAttribute("for", options.id);
    label.textContent = options.label;

    wrapper.appendChild(input);
    wrapper.appendChild(label);

    if (options.hiddenName) {
      var hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = options.hiddenName;

      input.addEventListener("input", function () {
        hidden.value = input.value;
      });

      wrapper.appendChild(hidden);
    }

    if (options.mirrorFirstName) {
      var firstName = document.createElement("input");
      firstName.type = "hidden";
      firstName.name = "customer[first_name]";

      input.addEventListener("input", function () {
        firstName.value = input.value;
      });

      wrapper.appendChild(firstName);
    }

    if (options.hiddenLastName) {
      var lastName = document.createElement("input");
      lastName.type = "hidden";
      lastName.name = "customer[last_name]";
      lastName.value = "-";
      wrapper.appendChild(lastName);
    }

    return wrapper;
  }

  function createFields() {
    var grid = document.createElement("div");
    grid.className = FIELDSET_CLASS;

    [
      {
        id: "company-field",
        name: "company-field",
        label: "Razão Social",
        autocomplete: "organization",
        full: true,
        hiddenName: "customer[note][Razão Social]",
        mirrorFirstName: true,
        hiddenLastName: true,
      },
      {
        id: "cnpj-field",
        name: "cnpj-field",
        label: "CNPJ",
        autocomplete: "off",
        inputMode: "numeric",
        hiddenName: "customer[note][CNPJ]",
      },
      {
        id: "city-field",
        name: "city-field",
        label: "Cidade",
        autocomplete: "address-level2",
        hiddenName: "customer[note][Cidade]",
      },
      {
        id: "state-field",
        name: "state-field",
        label: "UF",
        autocomplete: "address-level1",
        hiddenName: "customer[note][UF]",
      },
      {
        id: "register-email",
        name: "customer[email]",
        label: "E-mail",
        type: "email",
        autocomplete: "email",
      },
      {
        id: "phone-field",
        name: "phone-field",
        label: "Telefone",
        type: "tel",
        autocomplete: "tel",
        inputMode: "tel",
        hiddenName: "customer[note][Telefone]",
      },
      {
        id: "register-password",
        name: "customer[password]",
        label: "Senha",
        type: "password",
        autocomplete: "new-password",
        full: true,
      },
    ].forEach(function (field) {
      grid.appendChild(createInputField(field));
    });

    return grid;
  }

  function moveSubmitButton(form, grid) {
    var submits = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"], button:not([type]), input[type="submit"]'));
    var submit = submits.shift();

    if (!submit) {
      return;
    }

    submits.forEach(function (extraSubmit) {
      var extraWrapper = findWrapper(extraSubmit);

      if (extraWrapper && extraWrapper !== form) {
        extraWrapper.remove();
      } else {
        extraSubmit.remove();
      }
    });

    var submitWrapper = findWrapper(submit);
    var actions = document.createElement("div");
    actions.className = "customer-register-actions";

    actions.appendChild(submit);
    grid.appendChild(actions);

    if (submitWrapper && submitWrapper !== submit && submitWrapper.parentElement && submitWrapper.children.length === 0) {
      submitWrapper.remove();
    }
  }

  function removeCurrentFields(form) {
    form.querySelectorAll("." + FIELDSET_CLASS).forEach(function (grid) {
      grid.remove();
    });

    var inputs = form.querySelectorAll("input, select, textarea");

    inputs.forEach(function (input) {
      var name = input.name || "";

      if (
        input.type === "hidden" &&
        name !== "customer[first_name]" &&
        name.indexOf("customer[note]") !== 0
      ) {
        return;
      }

      if (input.type === "submit") {
        return;
      }

      if (input.type === "hidden") {
        input.remove();
        return;
      }

      var wrapper = findWrapper(input);
      if (wrapper) {
        wrapper.remove();
      } else {
        input.remove();
      }
    });
  }

  function customizeRegisterForms() {
    document.querySelectorAll("form").forEach(function (form) {
      ensureLastName(form);

      if (form.closest(".ymq-lock-register-form")) {
        return;
      }

      var isRegisterContext =
        isRegisterForm(form) ||
        !!form.closest(".customer.register, #bss-b2b-registration-form-render");

      if (!isRegisterContext) {
        return;
      }

      bindAddressSync(form);

      var hasRequestedFields =
        !!form.querySelector("#company-field, #RegisterForm-Company") &&
        !!form.querySelector("#cnpj-field, #RegisterForm-Cnpj") &&
        !!form.querySelector("#city-field, #RegisterForm-City") &&
        !!form.querySelector("#state-field, #RegisterForm-State") &&
        !!form.querySelector("#phone-field, #RegisterForm-Phone");
      var hasLegacyFields = Array.prototype.some.call(form.querySelectorAll("input, select, textarea"), function (input) {
        if (input.closest("." + FIELDSET_CLASS)) {
          return false;
        }

        if (input.type === "hidden" || input.type === "submit") {
          return false;
        }

        return true;
      });
      var hasDuplicatedGrid = form.querySelectorAll("." + FIELDSET_CLASS).length > 1;

      if (hasRequestedFields && !hasLegacyFields && !hasDuplicatedGrid) {
        form.dataset.customRegisterLocation = "complete";
        return;
      }

      if (form.dataset.customRegisterLocation === "complete" && !hasLegacyFields && !hasDuplicatedGrid) {
        return;
      }

      if (!isRegisterForm(form) && !hasLegacyFields && !hasDuplicatedGrid) {
        return;
      }

      var firstField = findWrapper(form.querySelector("input:not([type='hidden']), select, textarea"));
      var submit = form.querySelector('button[type="submit"], button:not([type]), input[type="submit"]');
      var anchor = firstField || findWrapper(submit) || submit;
      var grid = createFields();

      removeCurrentFields(form);

      if (anchor && anchor.parentNode === form) {
        form.insertBefore(grid, anchor);
      } else {
        form.appendChild(grid);
      }

      moveSubmitButton(form, grid);
      bindAddressSync(form);
      form.dataset.customRegisterLocation = "complete";
    });
  }

  document.addEventListener("DOMContentLoaded", customizeRegisterForms);
  window.addEventListener("load", customizeRegisterForms);
  document.addEventListener(
    "submit",
    function (event) {
      ensureLastName(event.target);
    },
    true
  );

  new MutationObserver(customizeRegisterForms).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
